//
// Generated class UserReportAccess
//

/// <reference path="UserReportAccess_ManagedObject.ts" />

class UserReportAccess extends UserReportAccess_ManagedObject
{
}
